<template>
  <div class="Footer">@hebic.cn 招生办公室 0311-85334781</div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
.Footer {
  height: 72px;
  line-height: 72px;
  text-align: center;
  color: #9fa4b4;
  font-size: 14px;
}

@media only screen and (max-width: 600px) {
  .Footer {
    height: 55px;
    line-height: 55px;
  }
}
</style>
